import { useQuery } from '@tanstack/react-query';
import { http } from 'services/http';
import { TRIP_STEPS_MANY } from 'api/query-keys.ts';
import type { TTripStepsRes } from 'api/swagger';

interface IParams {
  tripId: number;
  enabled?: boolean;
}

export const useGetTripSteps = (params: IParams) => {
  const { tripId, enabled = true } = params;
  return useQuery<TTripStepsRes[]>({
    queryKey: [TRIP_STEPS_MANY, tripId],
    queryFn: async () => {
      const { data } = await http.get<TTripStepsRes[]>(`/v1/trips/${tripId}/trip-steps`);
      return data;
    },
    retry: false,
    refetchOnWindowFocus: false,
    staleTime: 10 * 1000,
    cacheTime: 20 * 1000,
    enabled,
  });
};
